import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface SubpageNavbarProps {
  currentPage?: 'galerie' | 'nabidka-bytu' | 'o-projektu';
}
interface NavLink {
  name: string;
  href: string;
  isPage?: boolean;
  isHome?: boolean;
}
export function SubpageNavbar({
  currentPage
}: SubpageNavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks: NavLink[] = [{
    name: 'Home',
    href: '#home',
    isHome: true
  }, {
    name: 'O projektu',
    href: '#o-projektu-stranka',
    isPage: true
  }, {
    name: 'Galerie',
    href: '#cela-galerie',
    isPage: true
  }, {
    name: 'Výhody',
    href: '#vyhody'
  }, {
    name: 'Lokalita',
    href: '#lokalita'
  }, {
    name: 'Nabídka bytů',
    href: '#nabidka-bytu',
    isPage: true
  }, {
    name: 'Kontakt',
    href: '#kontakt'
  }];
  const handleNavClick = (href: string, isPage?: boolean, isHome?: boolean) => {
    setIsMobileMenuOpen(false);
    // If it's the home link, navigate to the main page
    if (isHome) {
      window.location.hash = '';
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    // If it's a page link (like #cela-galerie or #nabidka-bytu), just navigate
    if (isPage) {
      window.location.hash = href.replace('#', '');
      return;
    }
    // If it's an anchor link and we're on a subpage, go to main page first
    if (href.startsWith('#') && href !== '#') {
      window.location.hash = '';
      // Small delay to let the main page load, then scroll to section
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };
  const isActive = (href: string) => {
    if (currentPage === 'o-projektu' && href === '#o-projektu-stranka') return true;
    if (currentPage === 'galerie' && href === '#cela-galerie') return true;
    if (currentPage === 'nabidka-bytu' && href === '#nabidka-bytu') return true;
    return false;
  };
  return <nav className="bg-base-cream/95 backdrop-blur-md shadow-sm py-4 sticky top-0 z-50" data-id="element-229">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-230">
        <a href="#" onClick={e => {
        e.preventDefault();
        window.location.hash = '';
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="font-heading text-2xl font-bold tracking-wide text-primary" data-id="element-231">
          Svatý Václav
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-232">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
          e.preventDefault();
          handleNavClick(link.href, link.isPage, link.isHome);
        }} className={`text-sm font-medium transition-colors hover:text-accent ${isActive(link.href) ? 'text-accent' : 'text-base-dark'}`} data-id="element-233">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-234">
          {isMobileMenuOpen ? <XIcon className="text-base-dark" data-id="element-235" /> : <MenuIcon className="text-base-dark" data-id="element-236" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-base-cream shadow-lg border-t border-gray-100 py-4 px-6 flex flex-col space-y-4" data-id="element-237">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
        e.preventDefault();
        handleNavClick(link.href, link.isPage, link.isHome);
      }} className={`font-medium py-2 border-b border-gray-100 last:border-none ${isActive(link.href) ? 'text-accent' : 'text-base-dark'}`} data-id="element-238">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}